export default function MessageBox({ type = "info", message, onClose }) {
  if (!message) return null;

  const baseStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    padding: "16px",
    display: "flex",
    justifyContent: "center",  // center text horizontally
    alignItems: "center",
    borderBottom: "2px solid",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    zIndex: 9999,
    fontFamily: "sans-serif",
    fontSize: "16px",
    fontWeight: "500",
  };

  const variants = {
    success: {
      backgroundColor: "#d1fae5", // light green
      borderColor: "#10b981",    // green
      color: "#065f46",          // dark green
    },
    error: {
      backgroundColor: "#fee2e2", // light red
      borderColor: "#ef4444",     // red
      color: "#991b1b",           // dark red
    },
    info: {
      backgroundColor: "#dbeafe", // light blue
      borderColor: "#3b82f6",     // blue
      color: "#1e3a8a",           // dark blue
    },
  };

  const style = { ...baseStyle, ...variants[type] };

  const buttonStyle = {
    position: "absolute",
    right: "16px",
    top: "5px",
    transform: "translateY(-50%)",
    border: "none",
    background: "transparent",
    fontWeight: "bold",
    fontSize: "24px",   // larger size
    cursor: "pointer",
    color: "inherit",
    lineHeight: "1",
  };

  return (
    <div style={style}>
      <span>{message}</span>
      <button style={buttonStyle} onClick={onClose} aria-label="Close">
        ✕
      </button>
    </div>
  );
}
